import React, { useEffect } from 'react'
import { BaseNodeProps } from '../../base/types'
import { MessageTypeConfiguration } from '../message-type/MessageTypeForm'
import { Handle, Position } from 'reactflow'
import NodeTemplate from '../../base/NodeTemplate'
import { ScriptConfiguration } from './ScriptForm'

const ScriptNode = React.memo(
  ({ data, isConnectable }: BaseNodeProps<ScriptConfiguration>) => {
    const title = 'Script'
    useEffect(() => {}, [])
    return (
      <>
        <Handle
          type="target"
          position={Position.Left}
          isConnectable={isConnectable}
        />
        <NodeTemplate icon={'filter'} title={title} name={data.name} />
        <Handle
          type="source"
          position={Position.Right}
          id="a"
          isConnectable={isConnectable}
        />
      </>
    )
  }
)

export default ScriptNode
